import { Helmet } from 'react-helmet'
import { useSearchParams } from 'react-router'

import { TabsContent } from '@/components/ui/tabs'
import { ToggleTabs } from '@/components/ui/ToggleTabs'
import { BookkeeperCustomers } from './BookkeeperCustomers'
import { InsuranceCustomers } from './InsuranceCustomers'

enum CustomerProduct {
  INSURANCE = 'insurance',
  BOOKKEEPER = 'bookkeeper',
}

export function Customers() {
  const [searchParams, setSearchParams] = useSearchParams()
  const product =
    searchParams.get('product') === CustomerProduct.BOOKKEEPER
      ? CustomerProduct.BOOKKEEPER
      : CustomerProduct.INSURANCE

  return (
    <>
      <Helmet>
        <title>Customers</title>
      </Helmet>
      <div className="flex max-w-7xl flex-col gap-5">
        <div className="mb-2 text-2xl font-semibold">Customers</div>
        <ToggleTabs
          value={product}
          onValueChange={(value) =>
            setSearchParams(value === CustomerProduct.BOOKKEEPER ? { product: value } : {})
          }
          items={[
            { value: CustomerProduct.INSURANCE, label: 'Insurance' },
            { value: CustomerProduct.BOOKKEEPER, label: 'Bookkeeper' },
          ]}
        >
          <TabsContent value={CustomerProduct.INSURANCE}>
            {product === CustomerProduct.INSURANCE && <InsuranceCustomers />}
          </TabsContent>
          <TabsContent value={CustomerProduct.BOOKKEEPER}>
            {product === CustomerProduct.BOOKKEEPER && <BookkeeperCustomers />}
          </TabsContent>
        </ToggleTabs>
      </div>
    </>
  )
}
